import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { ToastModule } from 'primeng/toast';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { SearchService } from './core/service/search/search.service';
import { LoginComponent } from './shared/components/login/login.component';
import { ForgetPasswordComponent } from './shared/components/forget-password/forget-password.component';
import { UpdatePasswordComponent } from './shared/components/update-password/update-password.component';
import { AccountInfoComponent } from './shared/components/account-info/account-info.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PasswordModule } from 'primeng/password';
import { BadgeModule } from 'primeng/badge';
import { LogService } from './core/service/log/logservice';
import { UpdateService } from './core/service/update-password/update.service';
import { MessageService } from 'primeng/api';
import { EmailService } from './core/service/forgotPassword/email.service';
import { SidebarService } from './core/service/sidebar/sidebar.service';
import { AuthGuard } from './core/guards/auth.guard';
import { AuthService } from './core/service/Auth/authService';
import { httpInterceptorProviders } from './core/Interceptor';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TooltipModule } from 'primeng/tooltip';
import { CookieService } from 'ngx-cookie-service';
import { CsvService } from './core/service/csvdownload/csv';
import { TestComponent } from './shared/components/test/test.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { offlineService } from './core/service/notification/Notification.service';
import { VerifyOtpComponent } from './shared/components/verify-otp/verify-otp.component';
import { detailService } from './core/service/order/orderexport';
import { ChangePasswordComponent } from './shared/components/change-password/change-password.component';
import { TwoDigitDecimaNumberDirective } from './shared/directives/decimal.directive';
import { zipdownloadService } from './core/service/zipexport/zipexport';
import { MagicLoginComponent } from './shared/components/magic-login/magic-login.component';
import { MagicVerifcationComponent } from './shared/components/magic-verifcation/magic-verifcation.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgetPasswordComponent,
    UpdatePasswordComponent,
    AccountInfoComponent,
    TestComponent,
    VerifyOtpComponent,
    ChangePasswordComponent,
    TwoDigitDecimaNumberDirective,
    MagicLoginComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    HttpClientModule,
    PasswordModule,
    TooltipModule,
    ToastModule,
    BadgeModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    offlineService,
    SearchService,
    LogService,
    UpdateService,
    MessageService,
    EmailService,
    SidebarService,
    AuthGuard,
    AuthService,
    httpInterceptorProviders,
    CookieService,
    CsvService,
    detailService,
    zipdownloadService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
